import React, { useState, setState, useEffect, useContext } from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { UserContext } from '../contexts/UserContext';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Time from 'react-time';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import CancelIcon from '@material-ui/icons/Cancel';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function WagersInfo(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    appBar: {
      position: 'relative',
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: '0 auto',
      border: '1px grey black',
      textAlign: 'center',
      width: '600px',
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: 200,
      },
      '& .MuiFormGroup-row': {
        justifyContent: 'center',
      },
      '& .MuiFormControl-root': {
        justifyContent: 'center',
      },
    },
  }));
  const classes = useStyles();

  return (
    <React.Fragment>
      <br />
      <form className={classes.center}>
        <FormGroup>
          <FormControl className={`${classes.formControl} w-full`} size='small' variant='outlined'>
            <Table>
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classes.headerCell}>
                    <strong>User</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Placed</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Player</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Description</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Points</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Odds</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Risk</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Win</strong>
                  </TableCell>
                  <TableCell className={classes.headerCell}>
                    <strong>Station</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {props.WagersValues &&
                  props.WagersValues.map((row) => (
                    <TableRow className={classes.tableRow}>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[2]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>
                          <Time value={row[3].date} format="DD/MM/YYYY" />
                        </strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[4]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[5]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[11]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[6]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[7]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[8]}</strong>
                      </TableCell>
                      <TableCell className={classes.headerCell}>
                        <strong>{row[1]}</strong>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </FormControl>
        </FormGroup>
      </form>
    </React.Fragment>
  );
}
